import {
  TableContainer,
  Table,
  TableHead,
  TableHeadCell,
  TableBody,
  TableRow,
  Typography,
  Paginator,
} from '@safedns/skydns-ui-react-lib';

import { useGetUserQuery, useGetDomainsQuery } from '../../services/ADapi';

import DomainsListItem from './DomainsListItem';
import FetchError from '../UI/fetch-error/FetchError';
import Loader from '../UI/loader/Loader';

import usePagination from '../../hooks/usePagination';
import { actionTableCellStyle } from '../../styles/tableStyles';

const DomainsList = () => {
  const {
    data: { user_id },
  } = useGetUserQuery();
  const {
    data: domains = [],
    isError,
    isLoading,
  } = useGetDomainsQuery(user_id);

  const itemsCount = 5;
  const {
    firstContentIndex,
    lastContentIndex,
    page,
    gaps,
    totalPages,
    setPage,
    nextPage,
    prevPage,
  } = usePagination({
    contentPerPage: itemsCount,
    count: domains && domains.length,
  });

  if (isLoading) {
    return <Loader text="Please wait..." />;
  }

  if (isError) {
    return <FetchError />;
  }

  if (!domains && !isLoading && !isError) {
    return (
      <Typography variant="body1" component="p">
        Нет созданных доменов
      </Typography>
    );
  }

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell sx={{ textAlign: 'left' }}>Домены</TableHeadCell>
              <TableHeadCell sx={{ textAlign: 'left' }}>Группы</TableHeadCell>
              <TableHeadCell sx={{ textAlign: 'left' }}>
                Пользователи
              </TableHeadCell>
              <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
              <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {domains.slice(firstContentIndex, lastContentIndex).map((item) => (
              <DomainsListItem
                key={item.id}
                id={item.id}
                domain={item.name}
                groups={item.groups_count}
                users={item.ad_users_count}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {domains.length > itemsCount && (
        <Paginator
          nextPage={nextPage}
          prevPage={prevPage}
          page={page}
          gaps={gaps}
          setPage={setPage}
          totalPages={totalPages}
        />
      )}
    </>
  );
};

export default DomainsList;
